export const na1 = 'na1';
export const test2 = 'test2';
export const eu1 = 'eu1';